import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  orderId: null,
  listingTitle: null,
  sellerName: null,
};

const orderConfirmedPageSlice = createSlice({
  name: 'app/OrderConfirmedPage',
  initialState,
  reducers: {
    setInitialValues(state, action) {
      return { ...state, ...action.payload };
    },
  },
});

export const { setInitialValues } = orderConfirmedPageSlice.actions;
export default orderConfirmedPageSlice.reducer;
